query GetGuessedInstanceWebsite {
    sessionInstance {
        guessedInstanceWebsite
    }
}
